import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import API from '../../Services/API';
import _ from 'lodash';
//
// @params data.type list or single
//
export const LoadReceipt = createAsyncThunk('receipt/load', async (data) => {
  const params = {
    company_id: data.companyId || process.env.REACT_APP_COMP_EMM,
    $filter: data.filter,
    $count: true,
    $skip: (data.currentPage - 1) * data.pageSize,
    $top: data.pageSize,
    $select: data.select
  };
  if (isNaN(params.$skip) || params.$skip < 0) {
    delete params.$skip;
  }
  if (data.skipPaginate === true) {
    delete params.$skip;
    delete params.$top;
  }
  const res = await API().get(`/purchase_order_receipts`, { params });
  return {
    receipts: res.data.value,
    count: res.data['@odata.count'],
    type: data.type
  };
});

export const LoadReceiptLines = createAsyncThunk('receipt/lines', async (data) => {
  const params = {
    company_id: data.companyId || process.env.REACT_APP_COMP_EMM,
    $filter: data.filter,
    $count: true
  };
  const res = await API().get(`/purchase_receipt_lines`, { params });
  return {
    lines: res.data.value,
    count: res.data['@odata.count']
  };
});

export const LoadSearchedReceipts = createAsyncThunk('receipt/search', async (data) => {
  const params = {
    company_id: data.companyId || process.env.REACT_APP_COMP_EMM,
    $filter: data.filter
  };
  const res = await API().get(`/purchase_order_receipts`, { params });
  return {
    receipts: res.data.value
  };
});

const initialState = {
  list: [],
  count: 0,
  currentReceipt: {},
  fetchingReceipt: false,
  receiptLines: [],
  fetchingLines: false,
  linesCount: 0
};

const receiptSlice = createSlice({
  name: 'receipt',
  initialState,
  reducers: {
    resetReceiptSlice() {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(LoadReceipt.pending, () => {
      return {
        ...initialState,
        fetchingReceipt: true
      };
    });
    builder.addCase(LoadReceipt.fulfilled, (state, { payload }) => {
      if (payload.type === 'list') {
        state.list = payload.receipts.map((receipt) => {
          delete receipt['@odata.etag'];
          return receipt;
        });
        state.count = payload.count;
      } else {
        state.currentReceipt = payload.receipts.map((receipt) => {
          delete receipt['@odata.etag'];
          return receipt;
        })[0];
        state.count = 0;
      }
      state.fetchingReceipt = false;
    });
    builder.addCase(LoadReceipt.rejected, () => {
      return {
        ...initialState,
        fetchingReceipt: false
      };
    });
    builder.addCase(LoadSearchedReceipts.fulfilled, (state, { payload }) => {
      const searchedReceipts = payload.receipts.map((receipt) => {
        delete receipt['@odata.etag'];
        return receipt;
      });
      const combineReceipts = current(state).list.concat(searchedReceipts);
      state.list = _.uniqBy(combineReceipts, 'orderNumber');
    });
    builder.addCase(LoadReceiptLines.pending, (state) => {
      return {
        ...state,
        fetchingLines: true
      };
    });
    builder.addCase(LoadReceiptLines.fulfilled, (state, { payload }) => {
      state.receiptLines = payload.lines.map((line) => {
        delete line['@odata.etag'];
        return line;
      });
      state.linesCount = payload.count;
      state.fetchingLines = false;
    });
    builder.addCase(LoadReceiptLines.rejected, () => {
      return {
        ...initialState,
        fetchingLines: false
      };
    });
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default receiptSlice.reducer;
export const receiptAction = receiptSlice.actions;
